import React, { useState } from 'react';
import ConfirmationBlock from '../ConfirmationBlock';
import deleteImg from '../../../assets/images/warning-gif.gif';
import confirmImg from '../../../assets/images/confirm-gif.gif';
import Button from '../../molecules/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import domainService from '../../../services/domainService';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Toast from '../../molecules/Toast';

const DeleteDomain = ({ onClose, domainId }) => {
  const navigate = useNavigate();
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { refetch } = useContextHook(AuthContext, v => ({
    refetch: v.refetch,
  }));

  async function handleDeleteDomain() {
    try {
      setLoading(true);
      await domainService.deleteDomain(domainId);
      setConfirmDelete(true);
    } catch (err) {
      Toast({ type: 'erroe', message: err?.mesage });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      {!confirmDelete ? (
        <ConfirmationBlock
          img={deleteImg}
          title="Delete this Domain!"
          description="Are you sure you want to delete this domain? This action cannot be undone. Once this domain is deleted, all running campaigns will no longer be able to send emails using this domain."
          btns={
            <>
              <Button onClick={() => navigate('/email-accounts')}>Cancel</Button>
              <Button variant="danger" onClick={() => handleDeleteDomain()} loader={loading} disabled={loading}>
                Delete
              </Button>
            </>
          }
        />
      ) : (
        <ConfirmationBlock
          img={confirmImg}
          title="Domain Deleted Successfully!"
          btns={
            <Button
              onClick={() => {
                onClose();
                refetch();
              }}>
              Go Back
            </Button>
          }
        />
      )}
    </div>
  );
};

export default DeleteDomain;
